export var env = process.env.NODE_ENV === 'development';
export var isDevEnv = function(callback) {
    if (env) {
        if (typeof callback === 'function') {
            callback();
        }
        return true;
    }
    return false;
};
export function devMessage(message) {
    var messageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'log';
    console[messageType]("".concat(message, "\n\u2661 Carina"));
}
export function ifDevMessage(message) {
    if (isDevEnv()) {
        devMessage(message);
    }
}
